<template>
  <div>
    <main-sidebar
      :name="name"
      :title="($t('add') + ' ' + $t('trailer'))|capitalize"
    >
      <div class="p-4">
        <vs-row class="mb-2">
          <vs-col
            vs-type="flex"
            vs-justify="flex-start"
            vs-align="center"
            vs-w="12"
          >
            <label>{{ $t('transporter')|capitalize }}</label>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="flex-start"
            vs-align="center"
            vs-w="12"
          >
            <vs-input class="w-full" v-model="params.transporter" :disabled="true"/>
          </vs-col>
        </vs-row>
        
        <vs-row class="mb-2">
          <vs-col
            vs-type="flex"
            vs-justify="flex-start"
            vs-align="center"
            vs-w="12"
          >
            <label>{{ $t('name')|capitalize }}</label>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="flex-start"
            vs-align="center"
            vs-w="12"
          >
            <vs-input class="w-full" v-model="params.name"/>
          </vs-col>
        </vs-row>

        <vs-row class="mb-2">
          <vs-col
            vs-type="flex"
            vs-justify="flex-start"
            vs-align="center"
            vs-w="12"
          >
            <label>{{ $t('plates')|capitalize }}</label>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="flex-start"
            vs-align="center"
            vs-w="12"
          >
            <vs-input class="w-full" v-model="params.plates"/>
          </vs-col>
        </vs-row>

        <vs-row class="mb-2">
          <vs-col
            vs-type="flex"
            vs-justify="flex-start"
            vs-align="center"
            vs-w="12"
          >
            <label>{{ $tc('type')|capitalize }}</label>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="flex-start"
            vs-align="center"
            vs-w="12"
          >
            <v-select 
            v-model="params.type"
            :options="trailerTypes" class="w-full"  
            :reduce="trailer => trailer.id" label="type"  
            :disabled="trailerTypes.length == 0"/>
          </vs-col>
        </vs-row>

        <vs-row class="mb-2">
          <vs-col
            vs-type="flex"
            vs-justify="flex-start"
            vs-align="center"
            vs-w="12"
          >
            <label>{{ $t('container_type')|capitalize }}</label>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="flex-start"
            vs-align="center"
            vs-w="12"
          >
            <vs-input class="w-full" v-model="params.container_type"/>
          </vs-col>
        </vs-row>

        <vs-row class="mb-2">
          <vs-col
            vs-type="flex"
            vs-justify="flex-start"
            vs-align="center"
            vs-w="12"
          >
            <label>{{ $t('length')|capitalize }}</label>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="flex-start"
            vs-align="center"
            vs-w="6"
          >
            <vs-input class="w-full" v-model="params.length_ft"/>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="flex-start"
            vs-align="center"
            vs-w="6"
            class="p-3"
          >
             <label>ft</label>
          </vs-col>
        </vs-row>

        <vs-row class="mb-2">
          <vs-col
            vs-type="flex"
            vs-justify="flex-start"
            vs-align="center"
            vs-w="12"
          >
            <label>SCAC</label>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="flex-start"
            vs-align="center"
            vs-w="12"
          >
            <vs-input class="w-full" v-model="params.scac"/>
          </vs-col>
        </vs-row>

        <vs-row class="mb-2">
          <vs-col
            vs-type="flex"
            vs-justify="flex-start"
            vs-align="center"
            vs-w="12"
          >
            <label>CAAT</label>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="flex-start"
            vs-align="center"
            vs-w="12"
          >
            <vs-input class="w-full" v-model="params.caat"/>
          </vs-col>
        </vs-row>
      </div>

       <div class="mx-4" slot="footer">
          <vs-button color="primary" type="filled" class="mr-6" @click="submit">
              {{ $t('submit') }}
          </vs-button>
          <vs-button color="primary" type="border" @click="close">
              {{ $t('cancel') }}
          </vs-button>
        </div>
    </main-sidebar>
  </div>
</template>

<script>
import MainSidebar from '@/views/components/MainSidebar.vue'
import loadOrder from '@/http/requests/loadOrder'
import vSelect from 'vue-select'
import loading from '@/mixins/Loading'

export default {
  mixins: [loading],
  components: {
    MainSidebar,
    vSelect
  },
  props:{
     params: {
      type: Object,
      default: () => ({
        name:'',
        plates:'',
        type:'',
        container_type:'',
        length_ft:'',
        SCAC:'',
        CAAT:'',
        transporter:''
      }),
    }
  },
  data() {
    return {
      /* params:{
        name:'',
        plates:'',
        type:'',
        container_type:'',
        length_ft:'',
        SCAC:'',
        CAAT:'',
        transporter:''
      }, */
      name: 'add-trailer',
      trailerTypes:[],
      loading:{
        submit:false,
        trailer_types:false
      }      
    }
  },
  watch:{
    isLoading(val) {
      if (val) {
        this.openLoading(`loading-${this.name}-sidebar`)
      } else {
        this.closeLoading(`loading-${this.name}-sidebar`)
      }
    }
  },
  computed:{
      isLoading() {
        return this.loading.submit||
        this.loading.trailer_types
      }
  },
  methods: {
    close() {
        this.$store.dispatch('toggleSidebar', '')
    },
    getTrailerTypes(){
      this.loading.trailer_types=true
      loadOrder.trailerTypes().then(res => {
          this.trailerTypes=res.data.items
          this.loading.trailer_types=false
      }).catch(err => {
          console.log(err)
          this.loading.trailer_types=false
      })
    },
    submit(){
      this.loading.submit=true
      loadOrder.addTrailer(this.params).then(res => {
        this.$vs.notify({
          color: 'success',
          title: 'Success',
          text: 'Trailer Guardado'
        })
        this.loading.submit=false
        this.close()
      }).catch(err => {
        console.log(err)
        this.loading.submit=false
        if (422 === err.response.status) {
            const errors = err.response.data.errors
            const errorArray = Object.keys(errors).map(function (key) {
              return [key, errors[key]]
            })
            errorArray.forEach((element) => {
              this.$vs.notify({
                color: 'danger',
                title: 'Alert',
                text: element[1][0],
              })
            })
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Alert',
              text: 'SERVER ERROR',
            })
          }
      })
    }
  },
  mounted() {
      this.getTrailerTypes()
  },
}
</script>